import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteCompetitiveExamMasterName = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        examName: "",
        authority: "",
        authorityName: "",
        instituteSubjectMasterId: '',
        instituteGradeMasterId: []
    }

    const [formData, setFormData] = useState([])
    const [compatitiveExamData, setCompatitiveExamData] = useState(initialFormState)
    const [syllabusList, setSyllabusList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [authoritySort, setAuthoritySort] = useState(null);
    const [authorityNameSort, setAuthorityNameSort] = useState(null);
    const [examNameSort, setExamNameSort] = useState(null);
    const [gradeNameSort, setGradeNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["authority", "authorityName", "examName", "instituteCompetitiveExamNameMasterDetails.instituteGradeMasterDetails.gradeName", "instituteCompetitiveExamNameMasterSubjectDetails.instituteSubjectMasterDetails.subjectName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setFormData((pre) => {
                    return {
                        ...pre,
                        gradeData: response.data.result
                    }
                })
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        const apiUrl2 = `/get-institute-subjects?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setFormData((pre) => {
                    return {
                        ...pre,
                        subjectData: response.data.result
                    }
                })
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, []);

    const getApiUrl = () => {
        let apiUrl = '/get-institute-competitive-exam-name-master?';
        if (compatitiveExamData.instituteMasterId) {
            apiUrl += `instituteMasterId=${compatitiveExamData.instituteMasterId}&`;
        }

        if (compatitiveExamData.authority) {
            apiUrl += `authority=${compatitiveExamData.authority}&`;
        }

        if (compatitiveExamData.examName) {
            apiUrl += `examName=${compatitiveExamData.examName}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        getCompetitiveExamNameList();
    }, [compatitiveExamData]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getCompetitiveExamNameList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setSyllabusList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim(), "data"))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(syllabusList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(syllabusList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > syllabusList.length) {
            endIndex = syllabusList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(syllabusList.slice(startIndex, endIndex));
    }, [syllabusList, currPage, itemsPerPage]);

    const getCompetitiveExamNameList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setSyllabusList(response.data.data);
        } catch (error) {
            setSyllabusList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e, index) => {
        setCompatitiveExamData((prevData) => {
            if (e.target.name === 'syllabusStructureName') {
                // Update the value at the specified index
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = e.target.value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                }
            } else if (e.target.name === "authorityName" || e.target.name === "examName") {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value.toUpperCase(),
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                }
            }
        })
    }

    const handleChangeClass = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setCompatitiveExamData((prevData) => {
            return {
                ...prevData,
                instituteGradeMasterId: selectedIds,
            }
        })
    }

    const handleChangeSub = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setCompatitiveExamData((prevData) => {
            return {
                ...prevData,
                instituteSubjectMasterId: selectedIds,
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(compatitiveExamData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(compatitiveExamData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [compatitiveExamData])

    const addSyllabusType = async () => {
        if (validateForm()) {
            try {
                const apiUrl = `/add-institute-competitive-exam-name-master`;
                setLoading(true);
                const response = await authorizedAxiosInstitute.post(apiUrl, compatitiveExamData);
                setCompatitiveExamData((prevData) => {
                    return {
                        ...prevData,
                        syllabusStructureName: [''],
                        examName: ''
                    }
                })

                setSaveId(response.data.result.id);
                setAuthoritySort(null);
                setAuthorityNameSort(null);
                setExamNameSort(null);
                setGradeNameSort(null);
                setSubjectNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(compatitiveExamData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSyllabus = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-competitive-exam-name-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, syllabusList.length);
                await getCompetitiveExamNameList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(true);
            }
        }
    }

    const updateSyllabus = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-competitive-exam-name-master?id=${editId}`;
            const response = await authorizedAxios.put(apiUrl, compatitiveExamData);
            setEditId(null);
            setCompatitiveExamData((prevData) => {
                return {
                    ...prevData,
                    syllabusStructureName: [''],
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const SubList = formData?.subjectData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.subjectName
        }
    }) || [];

    const GradeList = formData?.gradeData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.gradeName
        }
    }) || [];

    useEffect(() => {
        if (authoritySort == true || authoritySort == false) {
            setAuthorityNameSort(null);
            setExamNameSort(null);
            setGradeNameSort(null);
        }
    }, [authoritySort])

    useEffect(() => {
        if (authorityNameSort == true || authorityNameSort == false) {
            setAuthoritySort(null);
            setExamNameSort(null);
            setGradeNameSort(null);
            setSubjectNameSort(null);
        }
    }, [authorityNameSort])

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setAuthoritySort(null);
            setAuthorityNameSort(null);
            setGradeNameSort(null);
            setSubjectNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (gradeNameSort == true || gradeNameSort == false) {
            setAuthoritySort(null);
            setAuthorityNameSort(null);
            setExamNameSort(null);
            setSubjectNameSort(null);
        }
    }, [gradeNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setAuthoritySort(null);
            setAuthorityNameSort(null);
            setExamNameSort(null);
            setGradeNameSort(null);
        }
    }, [subjectNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Name Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-clipboard-list"></i>Competitive Exam Name Master</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={GradeList.filter(option =>
                                                            compatitiveExamData.instituteGradeMasterId && compatitiveExamData.instituteGradeMasterId.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="instituteGradeMasterId"
                                                        options={GradeList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeClass}
                                                    />
                                                    {error.instituteGradeMasterId && <p style={{ color: 'red' }}>{error.instituteGradeMasterId}</p>}
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <Select
                                                        value={SubList.filter(option =>
                                                            compatitiveExamData.instituteSubjectMasterId && compatitiveExamData.instituteSubjectMasterId.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="instituteSubjectMasterId"
                                                        options={SubList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeSub}
                                                    />
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name :</label>
                                                    <input type="text" className="form-control" id={`examName`} name='examName' onChange={handleInputChange} value={compatitiveExamData.examName} />
                                                    {error.examName && <p style={{ color: 'red' }}>{error.examName}</p>}
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="authority" className="col-form-label"><span style={{ color: "red" }}>*</span>Authority :</label>
                                                    <select class="form-select" aria-label="Default select example" name='authority' onChange={handleInputChange} value={compatitiveExamData.authority}>
                                                        <option selected value={''} disabled>Select Authority</option>
                                                        <option value={'govt'} >Government</option>
                                                        <option value={'pvt'} >Private</option>
                                                    </select>
                                                    {error.authority && <p style={{ color: 'red' }}>{error.authority}</p>}

                                                </div>
                                                <div className="col-md-4">
                                                    <label for="authorityName" className="col-form-label"><span style={{ color: "red" }}>*</span>Authority Name :</label>
                                                    <input type="text" className="form-control" id={`authorityName`} name='authorityName' onChange={handleInputChange} value={compatitiveExamData.authorityName} />
                                                    {error.authorityName && <p style={{ color: 'red' }}>{error.authorityName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId &&
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addSyllabusType}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setSyllabusList([]); setEditId(''); setCompatitiveExamData(initialFormState) }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSyllabus} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width ">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Authority
                                                                            <SortIcon sortState={authoritySort} setSortState={setAuthoritySort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"authority"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Authority Name
                                                                            <SortIcon sortState={authorityNameSort} setSortState={setAuthorityNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"authorityName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Class
                                                                            <SortIcon sortState={gradeNameSort} setSortState={setGradeNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamNameMasterDetails.instituteGradeMasterDetails.gradeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamNameMasterSubjectDetails.instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((syllabus, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{syllabus.authority === "pvt" ? "Private" : syllabus.authority === "govt" ? "Government" : ""}</td>
                                                                                        <td>{syllabus.authorityName}</td>
                                                                                        <td>{syllabus.examName}</td>
                                                                                        <td>{syllabus?.instituteCompetitiveExamNameMasterDetails?.map((i) => (i.instituteGradeMasterDetails.gradeName)).join(", ")}</td>
                                                                                        <td>{syllabus?.instituteCompetitiveExamNameMasterSubjectDetails?.map((i) => (i.instituteSubjectMasterDetails.subjectName)).join(", ")}</td>
                                                                                        <td>
                                                                                            {/* <button disabled className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setCompatitiveExamData({
                                                                                                    authority: syllabus.authority,
                                                                                                    authorityName: syllabus.authorityName,
                                                                                                    examName: syllabus.examName,
                                                                                                    instituteGradeMasterId: [syllabus.gradeMasterDetails.id.toString()],
                                                                                                    instituteSubjectMasterId: syllabus.subjectMasterDetails.id
                                                                                                });
                                                                                                setEditId(syllabus.id)
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button> */}
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteSyllabus(syllabus.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: "50px" }}>No Syllabus Structure Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={syllabusList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteCompetitiveExamMasterName;